import React from 'react';
import { settingsFormTypes, searchTableTypes, actionTypes } from '../../constants';
import { getArrayIds } from '../helpers/HelperFunctions';
import { Table } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import { loadListData } from './ListHelpers';
import { CompanySettingsForm } from '../forms/CompanySettingsForm';
import { messageDialog } from '../ModalDialogsTemplates';
import { showModalDialog, hideModalDialog } from '../ModalDialog';
import i18next from "../../i18n";
export async function loadData(page, pageSize, sortBy = '', isDesk = false, filterValues = []) {
    await loadListData.bind(this)(`Table/Get?searchTableTypes=${searchTableTypes.Companies}`, page, pageSize, sortBy, isDesk, filterValues);
}
export async function actionHandlerCallback(actionType, ids) {
    if (ids.length > 0) {
        switch (actionType) {
            case actionTypes.edit:
                const onSubmit = () => {
                    messageDialog(i18next.t("done"), i18next.t("companySettingsSuccesMessage"));
                }
                showModalDialog("modalDialog", i18next.t("editCompany"), "", <CompanySettingsForm companyId={ids[0]} onSubmitedHandler={() => onSubmit()} onCloseHandler={() => { hideModalDialog("modalDialog"); }} />, "feedPopup");
                break;
            default:
                await this.actionHandlerCallbackDefault(actionType, ids);
                break;
        }
    }
}
export function renderContent() {
    const { content, sortBy, isDesk, page, pageSize, pageCount, filterValues } = this.state;
    const { type, hideFilter } = this.props;
    return (
        <div>
            {type !== settingsFormTypes.settingsType && !hideFilter ?
                <TableFilterBlock filterValues={filterValues} onSearch={this.onSearch} exportFileName="companies" onSearchClear={this.onSearchClear} onColumnsUpdateHandler={this.onColumnsUpdateHandler} columnsSettings={{ columns: (content && content.allColumns) ? content.allColumns : [], selected: (content && content.columns) ? getArrayIds(content.columns) : [] }} getItems={this.getItemsForExport} /> :
                ""
            }
            {content && content.columns &&
                <Table onColumnFilter={this.onColumnFilter} allowDoubleClickAction={true} allCount={content.allCount} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} actionsForAll={content.actionsForAll} columns={content.columns} items={content.rows} showPagination={type !== settingsFormTypes.settingsType} sortBy={sortBy} isDesk={isDesk} page={page} pageSize={pageSize} pageCount={pageCount} handlePageChange={this.handlePageChange} handleChangePageSize={this.handleChangePageSize} />
            }
        </div>
    );
}